<template>
    <div class="mj__inner-content mj__list-grid">
        <router-link :to="'/content/channels/edit/' + item.id" class="mj__list-item" v-for="item in collections" :key="item.id">
            <div class="mj__list-item-bg" v-bind:style="{'background-image': 'url(' + (item.background_image ? item.background_image : '/static/assets/img/empty-city.jpg') + ')'}"></div>
            <div class="mj__list-item-title">
                {{ item.title }}
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
  name: 'MyChannelsList',
  data () {
    return {
    }
  },
  computed: {
    collections () {
      let channels = this.$store.state.myChannels

      if (channels) {
        channels = channels.reverse()
      }

      return channels
    }
  },
  created () {
    this.$store.dispatch('getMyChannels')
  }
}
</script>
<style lang="scss" scoped>
    .flex {
        display: flex;
    }
    .mj__content-grid {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 0 0 auto;
    }
    .row {
        margin-bottom: 20px;
    }
</style>
